export default __webpack_public_path__ + "2ecea7154cffc4b6388cb4c609847f4f.png";